import _get from 'lodash/get';
import { RootState } from 'app/reducer';
import ListingFilter from 'modules/Layout/component/Listing/Filter';
import {
  PartialSearchingProps,
  PaginationParams,
  SearchParams
} from 'modules/Shared/type';
import {
  SetSensorListParamsAction,
  setSensorListParamsAction
} from 'modules/Sensor/action/sensorList';
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FilterInputType } from 'modules/Layout/type';

export interface StateProps {
  filter: SearchParams;
  pagination: PaginationParams;
}

export interface DispatchProps {
  setParams: (payload: PartialSearchingProps) => SetSensorListParamsAction;
}

export interface Props extends StateProps, DispatchProps {
  values?: SearchParams;
}

export const mapState = (state: RootState): StateProps => {
  const { filter, pagination } = state.sensor.sensorList;

  return { filter, pagination };
};

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setSensorListParamsAction(payload))
});

export class SensorFilter extends React.Component<Props> {
  protected staticInputs: FilterInputType[];

  constructor(props: Props) {
    super(props);

    const { values = {} } = props;
    this.staticInputs = [
      {
        type: 'text',
        property: 'sensor_id',
        label: 'Mac',
        value: _get(values, 'sensor_id')
      },
      {
        type: 'text',
        property: 'email',
        label: 'Owner email',
        value: _get(values, 'email')
      },
      {
        type: 'text',
        property: 'username',
        label: 'Owner username',
        value: _get(values, 'username')
      },
      {
        type: 'text',
        property: 'nickname',
        label: 'Plant nickname',
        value: _get(values, 'nickname')
      },
      {
        type: 'switch',
        property: 'with_deleted',
        label: 'Show all with deleted',
        value: _get(values, 'with_deleted')
      }
    ];
  }

  render(): ReactNode {
    const { filter, pagination, setParams } = this.props;

    return (
      <ListingFilter
        inputs={this.staticInputs}
        filter={filter}
        pagination={pagination}
        setParams={setParams}
      />
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(SensorFilter);
